export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 15;
export const KEY = 'e3a781de-0048-473b-90cc-0ce3168a2388';
export const MODAL_CLOSE_SEC = 2.5;
